import React from 'react'
import PropTypes from 'prop-types'
import styles from '../../../../css/RxartSecure/DevicesRS.module.css'
import { useTranslation } from 'react-i18next'

export default function StateRS ({ state, size }) {
  const { t } = useTranslation('dashboardDevice')

  const states = {
    AC: {
      label: t('modalRxartSecure.label26'), bgcolor: '#DBFADE', textcolor: '#00B812', divcolor: '#00B812'
    },
    FR: {
      label: t('modalRxartSecure.label27'), bgcolor: '#C3C3C3', textcolor: '#000000', divcolor: '#000000'
    },
    BL: {
      label: t('modalRxartSecure.label28'), bgcolor: '#FFCFCF', textcolor: '#FF0707', divcolor: '#FF0707'
    },
    U: {
      label: t('modalRxartSecure.label29'), bgcolor: '#C3EDF5', textcolor: '#0000EE', divcolor: '#0000EE'
    }
  }

  return (
    <>
      {state === 'AC'
        ? (
          <div className={styles.state} style={{ backgroundColor: `${states.AC.bgcolor}` }}>
            <div className={styles.stateCircle} style={{ backgroundColor: `${states.AC.divcolor}` }}></div>
            <p style={{ color: `${states.AC.textcolor}`, fontSize: `${size}` }}>{states.AC.label}</p>
          </div>
          )
        : state === 'FR'
          ? (
            <div className={styles.state} style={{ backgroundColor: `${states.FR.bgcolor}` }}>
              <div className={styles.stateCircle} style={{ backgroundColor: `${states.FR.divcolor}` }}></div>
              <p style={{ color: `${states.FR.textcolor}`, fontSize: `${size}` }}>{states.FR.label}</p>
            </div>
            )
          : state === 'U'
            ? (
            <div className={styles.state} style={{ backgroundColor: `${states.U.bgcolor}` }}>
              <div className={styles.stateCircle} style={{ backgroundColor: `${states.U.divcolor}` }}></div>
              <p style={{ color: `${states.U.textcolor}`, fontSize: `${size}` }}>{states.U.label}</p>
            </div>
              )
            : state === 'BL'
              ? (
            <div className={styles.state} style={{ backgroundColor: `${states.BL.bgcolor}` }}>
              <div className={styles.stateCircle} style={{ backgroundColor: `${states.BL.divcolor}` }}></div>
              <p style={{ color: `${states.BL.textcolor}`, fontSize: `${size}` }}>{states.BL.label}</p>
            </div>
                )
              : null
      }
    </>
  )
}

StateRS.propTypes = {
  state: PropTypes.string,
  size: PropTypes.string
}
